/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clear_SelectionInputs */

const en_clear_selection = /** @type {(inputs: Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear selection`)
};

const de_clear_selection = /** @type {(inputs: Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auswahl löschen`)
};

/**
* | output |
* | --- |
* | "Clear selection" |
*
* @param {Clear_SelectionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const clear_selection = /** @type {((inputs?: Clear_SelectionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clear_SelectionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_clear_selection(inputs)
	return en_clear_selection(inputs)
});